import { Star } from 'lucide-react'

interface StarRatingProps {
  rating: number
  size?: 'sm' | 'md' | 'lg'
  className?: string
  showValue?: boolean
}

const sizeMap = {
  sm: 'h-3 w-3 sm:h-3.5 sm:w-3.5',
  md: 'h-4 w-4 sm:h-5 sm:w-5',
  lg: 'h-5 w-5 sm:h-6 sm:w-6',
}

export default function StarRating({ rating, size = 'md', className = '', showValue = false }: StarRatingProps) {
  const safe = Math.max(0, Math.min(5, Number(rating) || 0))
  const stars = [1, 2, 3, 4, 5]

  return (
    <div className={`flex items-center gap-1 ${className}`}>
      {stars.map((star) => {
        const filled = safe >= star
        const half = !filled && safe >= star - 0.5
        return (
          <span key={star} className="relative inline-flex">
            <Star className={`${sizeMap[size]} text-gray-300`} />
            {(filled || half) && (
              <span
                className="absolute inset-0 overflow-hidden"
                style={{ width: filled ? '100%' : '50%' }}
              >
                <Star className={`${sizeMap[size]} text-yellow-400 fill-yellow-400`} />
              </span>
            )}
          </span>
        )
      })}
      {showValue && (
        <span className="ml-1 text-xs sm:text-sm font-medium text-gray-600">
          {safe > 0 ? safe.toFixed(1) : 'New'}
        </span>
      )}
    </div>
  )
}
